import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { AppointmentItems, getAppointmentConfigs } from 'services';

export type State = ApiState<AppointmentItems, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchAppointmentConfigs = createAsyncThunk(
  'get/appointmentconfigs',
  async () => await getAppointmentConfigs()
);

export const initialState = {
  isLoading: true,
  hasLoaded: false,
  data: {},
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const appointmentConfigsSlice = createSlice({
  name: 'appointmentConfigs',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAppointmentConfigs.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchAppointmentConfigs.fulfilled, (state, action: PayloadAction<AppointmentItems>) => {
      state.isLoading = false;
      state.data = action.payload;
      state.hasLoaded = true;
    });

    builder.addCase(fetchAppointmentConfigs.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const stateSelector_ = (state: { appointmentConfigs: State }): State => state.appointmentConfigs;

export const appointmentConfigs_ = createSelector(stateSelector_, (state) => state.data);

export const appointmentConfigsIsLoading_ = createSelector(stateSelector_, (state) => state.isLoading);

export const appointmentConfigsHasLoaded_ = createSelector(stateSelector_, (state) => state.hasLoaded);

export default appointmentConfigsSlice.reducer;
